import { useState } from "react";

import PropTypes from "prop-types";

import { createMechanicBackInStock } from "../../../../services/mechanic";

import Modal from "../Modal";
import ImagePlaceholder from "../../ImagePlaceholder/ImagePlaceholder";
import Price from "../../../Price/Price";
import { Button } from "../../index";
import { Bell } from "../../icons";

import classes from "./OutOfStockModal.module.css";

function OutOfStockModal(props) {
  const {
    isOpen,
    onClose,
    skuId,
    imageUrl,
    name,
    price,
    message,
    showNotifyMe,
  } = props;

  const [isNotifyMeLoading, setIsNotifyMeLoading] = useState(false);

  async function notifyMeClickedHandler() {
    setIsNotifyMeLoading(true);
    try {
      await createMechanicBackInStock(skuId);
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setIsNotifyMeLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={classes["modal"]}>
        <header className={classes["modal-header"]}>
          <h2>{message}</h2>
        </header>
        <div className={classes["modal-content"]}>
          <ImagePlaceholder
            src={imageUrl}
            alt={name}
            className={classes["modal-content__img"]}
          />
          <p className={classes["modal-content__name"]}>{name}</p>
          <Price
            className={classes["modal-content__price"]}
            value={price}
            suffix="جم"
            suffixClassName={classes["modal-content__price-suffix"]}
            valueClassName={classes["modal-content__price-value"]}
          />
        </div>
        {showNotifyMe && (
          <div>
            <Button
              type="primary"
              icon={<Bell />}
              onClick={notifyMeClickedHandler}
              loading={isNotifyMeLoading}
              disabled={isNotifyMeLoading}
            >
              نبهني لما المنتج يتوفر
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default OutOfStockModal;

OutOfStockModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  skuId: PropTypes.number,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  price: PropTypes.number,
  message: PropTypes.string.isRequired,
  showNotifyMe: PropTypes.bool,
};
